export const simplifyTradingVolume = (value) => {
  value = Number(value);

  if (isNaN(value)) return "0";

  const isNegative = value < 0;
  const absValue = Math.abs(value);

  let formatted;

  if (absValue === 0) {
    formatted = "0";
  } else if (absValue >= 1_000_000) {
    formatted =
      (absValue / 1_000_000).toFixed(2).replace(/\.0+$/, "") + "M";
  } else if (absValue >= 1_000) {
    formatted =
      (absValue / 1_000).toFixed(2).replace(/\.0+$/, "") + "K";
  } else {
    formatted = absValue.toFixed(2).replace(/\.0+$/, "");
  }

  // 🔑 Prevent "-0"
  if (formatted === "0") return "0";

  return isNegative ? `-${formatted}` : formatted;
};


export const formatTime = (timestamp) => {
  if (!timestamp) return ""; // Handle cases where the timestamp is undefined or null
  const date = new Date(timestamp);

  // Use toLocaleTimeString to get the formatted time in 12-hour format
  return date.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });
};

export const capitalizeFirstLetter = (str) => {
  if (!str) return ""; // Handle cases where the input is undefined, null, or empty
  return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
};

export const fetchUser = async (api, dispatch, storeUser) => {
  try {
    const response = await api("get", "users/index");

    if (response?.status) {
      const { data } = response;
      if (dispatch && storeUser) dispatch(storeUser(data));
      if (data?.token) localStorage.setItem("token", data.token);
      return data;
    }
    throw new Error("Failed to fetch user data");
  } catch (error) {
    console.error("🚀 -> fetchUser -> error:", error);
    throw error;
  }
};

export const fetchAdmin = async (api, dispatch, storeUser) => {
  try {
    const response = await api("get", "authorizeSuperAdmin/index");

    if (response?.status) {
      const { data } = response;
      if (dispatch && storeUser) dispatch(storeUser(data));
      if (data?.token) localStorage.setItem("token", data.token);
      return data;
    }
    throw new Error("Failed to fetch user data");
  } catch (error) {
    console.error("🚀 -> fetchUser -> error:", error);
    throw error;
  }
};

// This function takes a percentage string and formats it to four decimal places.
// If the input is not a valid percentage string, it returns the input as is.
// Example: "1.24545345%" -> "1.2455%"

export function formatPercentageToFourDecimals(percentageStr) {
  if (typeof percentageStr === "string" && percentageStr.includes("%")) {
    const numericValue = parseFloat(percentageStr.replace("%", ""));
    if (!isNaN(numericValue)) {
      return `${numericValue.toFixed(4)}%`;
    }
  }
  return percentageStr;
}

// Display/Hide "Monthly" and "All Time" tabs
export function isOlderThan7Days(createdAt) {
  const createdDate = new Date(createdAt); // backend date
  const now = new Date(); // current time
  const diffInMs = now - createdDate; // time difference in milliseconds

  const weekInMs = 7 * 24 * 60 * 60 * 1000; // 7 days in milliseconds

  return diffInMs >= weekInMs;
}
// Check the wallet address string length
export function isValidTRC20AddressLength(address) {
  const trc20Regex = /^T[1-9A-HJ-NP-Za-km-z]{33}$/;
  return trc20Regex.test(address);
}
export function getFutureDate(offset = { months: 0, years: 0 }) {
  const now = new Date();
  now.setMonth(now.getMonth() + (offset.months || 0));
  now.setFullYear(now.getFullYear() + (offset.years || 0));

  // Format to MM/DD/YYYY
  return now.toLocaleDateString('en-US');
}
